import { configureStore, createListenerMiddleware } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import { cfsApi } from './cfs-api';

// RTK Query update: Add required exports
if (window.PULSE.app.redux) {
    window.PULSE.app.redux.configureStore = configureStore;
    window.PULSE.app.redux.createSagaMiddleware = createSagaMiddleware;
    window.PULSE.app.redux.createListenerMiddleware = createListenerMiddleware;
    window.PULSE.app.redux.cfsApi = cfsApi;
} else {
    window.PULSE.app.redux = {
        reducers: {},
        sagas: {},
        configureStore: configureStore,
        createSagaMiddleware: createSagaMiddleware,
        createListenerMiddleware: createListenerMiddleware,
        cfsApi: cfsApi
    };
}
